// src/constants/constants.js
export const NAVBAR_HEIGHT = 130; // px
export const TOP_APP_BAR_HEIGHT = 70; //px
export const BOTTOM_NAV_BAR_HEIGHT = 60; // px
export const SAFE_AREA_TOP_CSS = "env(safe-area-inset-top, 0px)";
export const SAFE_AREA_BOTTOM_CSS = "env(safe-area-inset-bottom, 0px)";
export const APP_SHELL_LAYOUT = {
  TOP_APP_BAR_HEIGHT,
  BOTTOM_NAV_BAR_HEIGHT,
  SAFE_AREA_TOP_CSS,
  SAFE_AREA_BOTTOM_CSS,
  TOP_APP_BAR_OFFSET_CSS: `calc(${TOP_APP_BAR_HEIGHT}px + ${SAFE_AREA_TOP_CSS})`,
  BOTTOM_NAV_OFFSET_CSS: `calc(${BOTTOM_NAV_BAR_HEIGHT}px + ${SAFE_AREA_BOTTOM_CSS})`,
};
export const BOTTOM_ACTION_BUTTONS_POSITION = 80; // px
export const TOP_AUTOCOMPLETE_ICON_POSITION = 86; // px
export const MESSAGE_TABS_POSITION = 90; // px
export const SCROLLABLE_MESSAGE_LIST_POSITION = 90; // px
export const SCROLLABLE_MESSAGE_LIST_HEIGHT_OFFSET = 220; // px
export const US_RATINGS = ["G", "PG", "PG-13", "R", "M"];
export const TV_CATEGORIES = [
  "Drama",
  "Comedy",
  "Reality",
  "News",
  "Sports",
  "Documentary",
];

// UX-only force re-login cutoff for client sessions.
// If users/{uid}.lastSignedInAt is before this ISO datetime (or missing), user is signed out.
// Example: "2026-03-07T18:31:48Z"
export const UX_FORCE_SIGN_OUT_IF_LAST_SIGNED_IN_BEFORE = "2026-03-05T00:00:00Z";
